import React from "react";
import { Box, Alert, Typography, Button } from "@mui/material";

export default function ErrorCard({ error }) {
  return (
    <>
      <Box
        sx={{
          mx: "auto",
          mt: 3,
          mb: 3,
          p: 3,
          borderRadius: 2,
          backgroundColor: "#fff3f4",
          border: "1px solid #f44336",
        }}
      >
        <Alert severity="error" sx={{ mb: 2 }}>
          Nie udało się załadować danych.
        </Alert>

        <Typography variant="body1" sx={{ mb: 1 }}>
          Poniżej znajduje się szczegółowy opis błędu. Przekaż go zespołowi
          wsparcia technicznego:
        </Typography>

        <Box
          component="pre"
          sx={{
            whiteSpace: "pre-wrap",
            backgroundColor: "#fce4ec",
            p: 2,
            borderRadius: 1,
            fontSize: 14,
            color: "#880e4f",
            border: "1px solid #f8bbd0",
          }}
        >
          {error}
        </Box>

        <Button
          variant="contained"
          sx={{
            mt: 3,
            backgroundColor: "#850C70",
            "&:hover": { backgroundColor: "#5F0054" },
          }}
          onClick={() => window.location.reload()}
        >
          Spróbuj ponownie
        </Button>
      </Box>
    </>
  );
}
